import CityPageTemplate from "../city-template/CityPageTemplate";
import { elkhartConfig } from "./data";

export default function ElkhartPage() {
  return <CityPageTemplate config={elkhartConfig} />;
}